export const AUTH_KEYS = {
  ID_TOKEN: 'id_token',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  REDIRECT_URI: 'redirect_uri',
  CLIENT_ID: 'client_id',
  AUTHORIZATION_CODE: 'authorization_code',
  AUTHORIZATION_REQUEST: 'authorization_request',
  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  RESPONSE_TYPE: 'response_type',
  STATE: 'state',
  SCOPE: 'scope',
  NONCE: 'nonce',
  CODE: 'code',
  RETURN_URL: 'returnUrl',
  AUTH_ERROR: 'auth_error'
};

export const STAFF_IDENTITY_PROVIDER = 'HivveStaff';

export const AUTHORIZATION_REQUEST_EXPIRED = 'authorization_request_expired';

export const AUTHORIZATION_PATH = '/oauth2/authorize';

export const AUTHORIZATION_RESUME_PATH = '/oauth2/authorize/resume';

export const AUTH_ERROR_CODES = {
  AUTHORIZATION_REQUEST_INVALID: 'authorization_request_invalid',
  AUTHORIZATION_UNAVAILABLE: 'authorization_unavailable',
  PRODUCT_SIGN_IN_FAILED: 'product_sign_in_failed'
} as const;

export type AuthErrorCode = typeof AUTH_ERROR_CODES[keyof typeof AUTH_ERROR_CODES];

export interface AuthErrorAlert {
  message: string;
  type: 'warning' | 'danger';
}

export const AUTH_ERROR_ALERTS: Readonly<Record<AuthErrorCode, AuthErrorAlert>> = Object.freeze({
  [AUTH_ERROR_CODES.AUTHORIZATION_REQUEST_INVALID]: {
    message: 'We could not start your sign-in session. Please try again from the application.',
    type: 'danger'
  },
  [AUTH_ERROR_CODES.AUTHORIZATION_UNAVAILABLE]: {
    message: 'Sign-in is temporarily unavailable. Please try again in a few minutes.',
    type: 'danger'
  },
  [AUTH_ERROR_CODES.PRODUCT_SIGN_IN_FAILED]: {
    message: "We couldn't finish signing you in. Open the product again to retry.",
    type: 'warning'
  }
});

export function getAuthorizationRestartAlert(productName?: string): AuthErrorAlert {
  const canonicalProductName = productName?.trim();

  return {
    message: canonicalProductName
      ? `Signing in to ${canonicalProductName} took too long, so we've started again.`
      : "Signing in took too long, so we've started again.",
    type: 'warning'
  };
}

export function getAuthErrorAlert(error: string, productName?: string): AuthErrorAlert | undefined {
  if (!Object.prototype.hasOwnProperty.call(AUTH_ERROR_ALERTS, error)) {
    return undefined;
  }

  if (error === AUTH_ERROR_CODES.PRODUCT_SIGN_IN_FAILED && productName?.trim()) {
    const canonicalProductName = productName.trim();
    return {
      message: `We couldn't finish signing you in to ${canonicalProductName}. Open it again to retry.`,
      type: 'warning'
    };
  }

  return AUTH_ERROR_ALERTS[error as AuthErrorCode];
}

export const AUTH_STORAGE_KEYS = {
  CLIENT_ID: 'client-id',
  CLIENT_REDIRECT_URI: 'client-redirect-uri',
  CLIENT_CODE_CHALLENGE: 'client-code-challenge',
  CLIENT_CODE_CHALLENGE_METHOD: 'client-code-challenge-method',
  CLIENT_SCOPE: 'client-scope',
  CLIENT_NONCE: 'client-nonce',
  CLIENT_STATE: 'client-state',
  PRODUCT_AUTHORIZATION_RECOVERY: 'product-authorization-recovery',
  AUTHORIZATION_RESTART: 'authorization-restart',
  AUTHORIZATION_RESTART_NOTICE: 'authorization-restart-notice',
  REDIRECT: 'redirect'
};
